import React, { createContext, useContext, useMemo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { SUBSCRIPTION_SEASON, SUBSCRIPTION_OPEN } from "../../../../config/subscription/subscription.config";


const ToggleSubscriptionContext = createContext({ isOpenSubscription: SUBSCRIPTION_OPEN, season: SUBSCRIPTION_SEASON });

/**
 * @param {React.PropsWithChildren} props 
 * @returns 
 */
const ToggleSubscriptionProvider = ({ children }) => {
    const value = useMemo(() => ({ isOpenSubscription: SUBSCRIPTION_OPEN, season: SUBSCRIPTION_SEASON }), []);
    return <ToggleSubscriptionContext.Provider value={value}>{children}</ToggleSubscriptionContext.Provider>;
}

export const useToggleSubscription = () => useContext(ToggleSubscriptionContext);

export const OnlyIfOpenSubscriptionLayout = () => {
    const { isOpenSubscription } = useToggleSubscription();

    if(!isOpenSubscription) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
}

export default ToggleSubscriptionProvider;
